module.exports = __webpack_public_path__ + "media/images/public-step1-67e531f3afc9dd0720e64fe087761eb2.png";